/* Novelloq custom (3/11/2026): staffelbalk bovenin de cart-lade houden, ook na elke AJAX-verversing. */
(function () {
  function sync() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var top = drawer.querySelector('[data-nq-staffel-top]');
    var src = drawer.querySelector('.cart__foot .nq-staffel');
    if (!top) return;
    var html = src ? src.outerHTML : '';
    if (top.innerHTML !== html) top.innerHTML = html;
  }
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
